import React,{Component} from "react";
import "./header/Header.css";
import "../scss/general.css";
import logo from "./images/loading.gif";
import logonotfound from './images/recordnotfound.png';
import Cookies from "universal-cookie";
import {DownloadTableExcel} from "react-export-table-to-excel";
import ReactToPdf from "react-to-pdf";
import Moment from "moment";
const ref = React.createRef(null);
const cookies = new Cookies();
const axios = require("axios");
export default class Monthly_attendance_date extends Component {
    constructor(props) {
        super(props);
        this.state = {
        myitems: [],
        statustext:[],
        isLoaded: false,
        mylocation: [],
        mydepartments:[],
        islocation:false,
        locationcode:"01",
        departmentcode:1,
        locationname:"",
        departmentname:'',
        ErrMsg:<img src={logo} alt="Error"/>,
        ErrMsg2:"",
        today: new Date(),
        cMonth:new Date().getMonth(),
        cYear:new Date().getFullYear(),
        cValue:new Date().getFullYear()+'-'+new Date().getMonth(),
        sValue:new Date(),
        eValue:new Date(),
        input:{},
        DivClass: "ErrDiv",
        minDate:'',
        maxDate:'',
        divxls:"none",
        departmentname:'',
        leaveclass: "tdm"
        }
//        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleLoadData=this.handleLoadData.bind(this);
        this.handleSelectChange=this.handleSelectChange.bind(this);
    }
/*    downloadExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet(this.state.myitems);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
        //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
        XLSX.writeFile(workbook, this.state.locationname+".xlsx");
      };
  */  
    cur=(num)=> {
        let cnum=parseInt(num,0);
        if(num > 0)
            return Intl.NumberFormat("en-US", {maximumFractionDigits:2}).format(num);
        else
            return "-"
    }
    handleSelectChange=(e)=>{    
        this.setState({locationcode:e.target.value,locationname:e.nativeEvent.target[e.target.selectedIndex].text,myitems:[],divxls:'none'});
    }
    handleSelectChangedepartment=(e)=>{        
        this.setState({departmentcode:e.target.value,departmentname:e.nativeEvent.target[e.target.selectedIndex].text,myitems:[],divxls:'none'});
    }
    handleChange=(e)=>{
        if(e.target.name=="start")
        {
            this.setState({sValue:e.target.value,divxls:"none",myitems:[]});
        }
        else
        {
            this.setState({eValue:e.target.value,divxls:"none",myitems:[]});
        }   
    }
    handleLoadData(){
        document.body.style.cursor="wait";
        let input=this.state.input;
        input["start"]=Moment(this.state.sValue).format("DD/MM/YYYY");
        input["end"]=Moment(this.state.eValue).format("DD/MM/YYYY");
        input["location"]=this.state.locationcode;
        input["department"]=this.state.departmentcode;
        console.log(input);
        this.setState({ErrMsg:<img src={logo} alt="Not Found"/>,myitems:[],divxls:"none"});
        axios({
            method: 'post',
            url: cookies.get("phpclass")+"/index.php/user/get_periodic_attendance/",
            data:input,
            headers: {'Content-Type': 'multipart/form-data'}
        })
        .then((response)=> {
            console.log(response.data);
            if(response.data === 0)
            {
                document.body.style.cursor="default";
                this.setState({ErrMsg:<img src={logonotfound} alt="Not Found"/>,myitems:[],isLoaded:true, islocation:true,divxls:'none'});
            }
            else
            {
                document.body.style.cursor="default";
                this.setState({
                isLoaded: true,
                islocation:true,
                ErrMsg:"",
                divxls:"block",
                myitems: response.data
                });
            }   
        })
        .catch((response)=> {
            document.body.style.cursor="default";
            this.setState({ErrMsg:<img src={logonotfound} alt="Not Found"/>,myitems:[],isLoaded:true, islocation:true,divxls:'none'});
        });  
    }

    componentDidMount(){
        axios.all([
            axios({
                method: 'post',
                url: cookies.get("phpclass")+'/index.php/user/get_location/0',
                headers: {'Content-Type': 'multipart/form-data'}
            }),
            axios({
                method: 'post',
                url: cookies.get("phpclass")+'/index.php/user/get_departments/0',
                headers: {'Content-Type': 'multipart/form-data'}
            })
        ])
        .then(axios.spread((response,response1)=> {
                 if(response.data === 2)
                {
                    document.body.style.cursor="default";
                    this.setState({ErrMsg:<img src={logo} alt="Error"/>,islocation:false,isLoaded:true});
                }
                else
                {
                    document.body.style.cursor="default";
                    this.setState({
                    locationcode: response.data[0]["l_code"],
                    mydepartments:response1.data,
                    departmentcode:response1.data[0]["dept_id"],
                    departmentname:response1.data[0]["department"],
                    islocation: true,
                    isLoaded:true,
                    ErrMsg:"",
                    mylocation: response.data,
                    lcode:response.data[0]["l_code"],
                    locationname:response.data[0]["location"]
                    })
                };
            }))
            .catch(()=> {
                document.body.style.cursor="default";
                this.setState({ErrMsg:<img src={logo} alt="Error"/>});
            });    
    }
    render(){
        let isLoaded = this.state.isLoaded;
        let islocation=this.state.islocation;
        let items = this.state.myitems;    
        let litems = this.state.mylocation;
        let ditems=this.state.mydepartments;
        let fileName=this.state.locationname+"-"+this.state.departmentname+".pdf";
        if (!isLoaded && !islocation) 
        {
            return(
              <div className="center">
                {this.state.ErrMsg}
              </div>
            );
        } 
        else if(isLoaded && !islocation)
        {
            <div className="center">
               {this.state.ErrMsg}
            </div>
        }
        else if(isLoaded && islocation)
        {
            return(
            <div width="100%" align="center">
            <br></br>
            <div className="inner-profile33" >
            <span className="box-title">Attendance</span>
            <div className="inner-profile2" >
            <label style={{paddingLeft:2,width:"85px"}}>Location <font style={{color:"red"}}>*</font></label>
            <select id="location" name="location" style={{height:25,width:150,borderRadius:0}} onChange={this.handleSelectChange} >
                {litems.map((result,i)=>{
                return(
                    <option value={result.l_code} key={i}  >{result.location}</option>
                );
                })}
            </select>
            <br></br>
            <label style={{paddingLeft:2,width:"85px"}}>Department <font style={{color:"red"}}>*</font></label>
            <select id="department" name="department" style={{height:25,width:150,borderRadius:0}} onChange={this.handleSelectChangedepartment} >
                {ditems.map((result,i)=>{
                return(
                    <option value={result.dept_id} key={i}  >{result.department}</option>
                );
                })}
            </select>
            <br></br>
            <label style={{paddingLeft:2,width:"85px"}}>Month: <font style={{color:"red"}}>*</font> </label>
            <input style={{paddingLeft:5}} type="date" id="start" name="start"  onChange={this.handleChange} value={this.state.sValue} />
            <label style={{marginLeft:2}} >-</label>
            <input style={{marginLeft:3}} type="date" id="end" name="end"  onChange={this.handleChange} value={this.state.eValue} />
            
            <button type="submit" style={{background: "linear-gradient(to bottom , #ffffff 0%, white 100%)"}} onClick={this.handleLoadData}>Submit </button>
            <br></br>
            </div>
            <div style={{textAlign:"center",width:"100%"}}  ref={ref}>
            <div style={{textAlign:"left",width:"100%",display:this.state.divxls}}>
            <h6>{this.state.locationname}  </h6>
            <h6>{this.state.departmentname}</h6>
            <h7>From {Moment(this.state.sValue).format("DD/MM/YYYY")} - {Moment(this.state.eValue).format("DD/MM/YYYY")}</h7>
            </div>
            <table style={{width:"100%",paddingLeft:"1%",paddingTop:"10px"}} id="table-to-xls" ref={ref} >
            <thead>
                <tr className="tr">
                    <th className="thl" scope="col">Sr#</th>
                    <th className="thl" scope="col">ID</th>
                    <th className="thn" scope="col">Employee Name</th>
                    <th className="thl" scope="col">C/L</th>
                    <th className="thl" scope="col">S/L</th>
                    <th className="thl" scope="col">A/L</th>
                    <th className="thl" scope="col">LWP</th>
                    <th className="thl" scope="col">Absent</th>
                    <th className="thl" scope="col">CMP</th>
                    <th className="thl" scope="col">Total days</th>
                </tr>
            </thead>
            <tbody>
            {
                items.map((result ,i) => {
//                if(result.attemp_id='101013')
//                    {alert(result.att_days)}
                let attclass="tdml";
                var netatt=Number(result.att_days)+Number(result.offdays)+Number(result.totalleaves)+Number(result.cmp); //-Number(result.LWPhalf);
                let absentdays=Number(result.monthdays)-Number(result.att_days)-Number(result.offdays)-Number(result.totalleaves)-Number(result.lwp)-Number(result.cmp);
                return(
                    <tr className="trc" key={i}>
                        <td className={attclass}>{i+1}</td>
                        <td className={attclass}>{result.attemp_id}</td>
                        <td className="tdmn" >{result.name}</td>
                        <td className={attclass}>{this.cur(result.casual)}</td>
                        <td className={attclass}>{this.cur(result.sick)}</td>
                        <td className={attclass}>{this.cur(result.annual)}</td>
                        <td className={attclass}>{this.cur(result.lwp)}</td>

                        <td className={attclass}>{this.cur(absentdays)}</td>
                        <td className={attclass}>{this.cur(result.cmp)}</td>
                        <td className={attclass}>{this.cur(netatt)}</td>
                    </tr>
                );
                })
            }
            </tbody>
        </table>
        </div>
        <div style={{textAlign:"center",paddingTop:5,display:this.state.divxls}} >
            <DownloadTableExcel
                filename={this.state.locationname+this.state.departmentname}
                sheet="users"
                currentTableRef={ref.current}
                >
                <button style={{background:"linear-gradient(to bottom , #ffffff 0%, black 100%)"}}> Export excel </button>
            </DownloadTableExcel>
            <ReactToPdf targetRef={ref} filename={fileName} x={10} scale={0.9}>
                  {({toPdf}) => (
                    <button onClick={toPdf} style={{background:"linear-gradient(to bottom , #ffffff 0%, black 100%)"}}>Download pdf</button>
                  )}
            </ReactToPdf>
        </div>
        </div>
        <br></br><br></br>
        {this.state.ErrMsg}
        </div>    
        );
    }
}}
